<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-success tw-text-center tw-ml-auto tw-w-full">
            <img src="@/assets/img/icons/info-check.svg" class="tw-pb-3 tw-block tw-mx-auto tw-pointer-events-none">
            <h3 class="tw-font-bold tw-pb-5">Simulação enviada com sucesso</h3>
            <p class="tw-font-light">Irá ser contactado para ficar a saber quanto pode poupar com o Cartão Frota PRIO</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';
.form-success {
    @apply tw-flex tw-items-center tw-justify-center tw-flex-col;
    height: 400px;

    h3 {
        font-size: 24px;

        @screen lg {
            @apply tw-text-3xl;
        }
    }

    p {
        @apply tw-mx-auto;
        width: 80%;

        @screen lg {
            width: 52.5%;
        }
    }

    @screen lg {
        height: 400px;
    }
}

</style>
